"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _batchHttp = require("@apollo/client/link/batch-http");
var _client = require("@apollo/client");
var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));
var _cache = require("@apollo/client/cache");
var globals = _interopRequireWildcard(require("../sharedState/globals"));
var _settings = _interopRequireDefault(require("../settings"));
var _createAuthLink = _interopRequireDefault(require("./createAuthLink"));
var _errorLink = _interopRequireDefault(require("./errorLink"));
var _fragmentTypes = _interopRequireDefault(require("./fragmentTypes.json"));
var _refreshLink = _interopRequireDefault(require("./refreshLink"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Generated by scripts/extractGraphQLUnionTypes
var customFetch = function customFetch(uri, options) {
  var operations = JSON.parse(options.body);

  // The likelyhood of requests coming from `hercules` being batched together
  // with other requests is slim to none. The following heuristics should be
  // sufficient for our needs.
  var isHerculesRequest = Array.isArray(operations) ? operations.some(function (operation) {
    return operation.operationName.startsWith("Hercules");
  }) : operations.operationName.startsWith("Hercules");
  if (isHerculesRequest) {
    var newUrl = new URL(uri);
    var searchParams = new URLSearchParams(newUrl.search);
    searchParams.set("client", "hercules");
    newUrl.search = searchParams.toString();
    return (0, _isomorphicFetch.default)(newUrl.href, options);
  }
  return (0, _isomorphicFetch.default)(uri, options);
};
var createClient = function createClient(options) {
  if (globals.nobia != null && globals.nobia.sharedClient != null) {
    return globals.nobia.sharedClient;
  }
  var terminatingLink = options.terminatingLink;
  var _options$clientOption = options.clientOptions,
    clientOptions = _options$clientOption === void 0 ? {} : _options$clientOption,
    _options$extraLinks = options.extraLinks,
    extraLinks = _options$extraLinks === void 0 ? [] : _options$extraLinks,
    _options$cacheOptions = options.cacheOptions,
    cacheOptions = _options$cacheOptions === void 0 ? {} : _options$cacheOptions;
  var linksMiddleware = [].concat(extraLinks, [(0, _createAuthLink.default)(options.store), _errorLink.default]);
  if (_settings.default.useRefreshLink) {
    linksMiddleware.push((0, _refreshLink.default)(options.store));
  }
  if (terminatingLink) {
    linksMiddleware.push(terminatingLink);
  } else if (!_settings.default.disableApolloBatching) {
    linksMiddleware.push(new _batchHttp.BatchHttpLink({
      uri: options.uri,
      fetch: customFetch,
      credentials: _settings.default.clientCredentials,
      batchInterval: 10,
      batchKey: function batchKey(operation) {
        return operation.operationName.startsWith("Hercules") ? "hercules" : "omni";
      }
    }));
  } else {
    linksMiddleware.push(new _client.HttpLink({
      uri: options.uri,
      fetch: customFetch,
      credentials: _settings.default.clientCredentials
    }));
  }
  var link = _client.ApolloLink.from(linksMiddleware);
  var ssrCache =
  // eslint-disable-next-line no-underscore-dangle
  typeof window !== "undefined" && window.__APOLLO_STATE__ || {};
  var cache = new _cache.InMemoryCache(Object.assign({
    possibleTypes: _fragmentTypes.default
  }, cacheOptions)).restore(ssrCache);
  var client = new _client.ApolloClient(Object.assign({
    connectToDevTools: true,
    queryDeduplication: true,
    ssrMode: typeof window === "undefined",
    // ssrForceFetchDelay: 100,
    link: link,
    cache: cache
  }, clientOptions));
  if (globals.nobia != null) {
    globals.nobia.sharedClient = client;
  }
  return client;
};
var _default = exports.default = createClient;